// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-line[data-v-a102c8be] {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  background-color: var(--bg-color);
  color: white;
  cursor: pointer;
  justify-content: space-between;
}
.activity-line .left-section[data-v-a102c8be] {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 10px;
  margin-right: 0;
  font-size: 16px;
  width: 22%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.activity-line .right-section[data-v-a102c8be] {
  margin: auto;
  margin-right: 0;
  font-size: 16px;
  padding: 5px;
  width: 22%;
}
.activity-line .right-section .icon-wrapper[data-v-a102c8be] {
  color: white;
  margin: auto 0 auto auto;
  width: 34px;
  height: 34px;
}
.activity-line .right-section .icon-wrapper[data-v-a102c8be]:active::after {
  background: #025796;
}
.activity-line .right-section .icon-wrapper:active i[data-v-a102c8be] {
  color: #e2e2e2;
}
.activity-line .right-section .icon-wrapper i[data-v-a102c8be] {
  font-size: 18px;
}
.activity-line .right-section .icon-wrapper i[data-v-a102c8be]:hover {
  color: #e2e2e2;
}
.activity-line .right-section .icon-wrapper i.fa-phone[data-v-a102c8be] {
  transform: rotate(225deg);
}
.activity-line .central-section[data-v-a102c8be] {
  margin: auto;
  font-size: 18px;
  flex: 1;
  overflow: hidden;
}
.activity-line .central-section div[data-v-a102c8be] {
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/activity/ActivityLine.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".activity-line[data-v-a102c8be] {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: 0 10px;\n  background-color: var(--bg-color);\n  color: white;\n  cursor: pointer;\n  justify-content: space-between;\n}\n.activity-line .left-section[data-v-a102c8be] {\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: 10px;\n  margin-right: 0;\n  font-size: 16px;\n  width: 22%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.activity-line .right-section[data-v-a102c8be] {\n  margin: auto;\n  margin-right: 0;\n  font-size: 16px;\n  padding: 5px;\n  width: 22%;\n}\n.activity-line .right-section .icon-wrapper[data-v-a102c8be] {\n  color: white;\n  margin: auto 0 auto auto;\n  width: 34px;\n  height: 34px;\n}\n.activity-line .right-section .icon-wrapper[data-v-a102c8be]:active::after {\n  background: #025796;\n}\n.activity-line .right-section .icon-wrapper:active i[data-v-a102c8be] {\n  color: #e2e2e2;\n}\n.activity-line .right-section .icon-wrapper i[data-v-a102c8be] {\n  font-size: 18px;\n}\n.activity-line .right-section .icon-wrapper i[data-v-a102c8be]:hover {\n  color: #e2e2e2;\n}\n.activity-line .right-section .icon-wrapper i.fa-phone[data-v-a102c8be] {\n  transform: rotate(225deg);\n}\n.activity-line .central-section[data-v-a102c8be] {\n  margin: auto;\n  font-size: 18px;\n  flex: 1;\n  overflow: hidden;\n}\n.activity-line .central-section div[data-v-a102c8be] {\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
